import React, { memo } from 'react';
import DefaultBodyStyles from './DefaultBodyStyles';
import DefaultRecommended from './DefaultRecommended';
import DefaultTrending from './DefaultTrending';
import DefaultSuggestionClicked from '../../contracts/DefaultSuggestionClicked';

type OwnProps = {
  handleDefaultSuggestionClicked: DefaultSuggestionClicked;
  inModal?: boolean;
};

function DefaultSuggestions({
  handleDefaultSuggestionClicked,
  inModal = false
}: OwnProps) {
  return (
    <div
      className="flex h-auto flex-col gap-24"
      data-qa="Default Search Suggestions"
    >
      <DefaultBodyStyles
        inModal={inModal}
        handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
      />
      <DefaultRecommended
        inModal={inModal}
        handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
      />
      <DefaultTrending
        inModal={inModal}
        handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
      />
    </div>
  );
}

export default memo(DefaultSuggestions);
